export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';

export const FETCH_ALL = 'FETCH_ALL';
export const FETCH_THEME = 'FETCH_THEME';
export const FETCH_THEME_BY_ID = 'FETCH_THEME_BY_ID';
export const FETCH_CUSTOMER = 'FETCH_CUSTOMER';
export const FETCH_CUSTOMER_BY_ID = 'FETCH_CUSTOMER_BY_ID';
export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const LIKE = 'LIKE';
export const FETCH_BY_SEARCH = 'FETCH_BY_SEARCH';
export const GET_STYLES = 'GET_STYLES';
